export default __webpack_public_path__ + "static/media/img1.b2db4327.svg";